import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { formatCurrency } from 'Utils/helpers';

import { EmailAnchor } from 'Components/Anchor/EmailAnchor';
import { PhoneAnchor } from 'Components/Anchor/PhoneAnchor';

import classes from './nonAppCrewCard.module.css';

interface Props {
  id: number;
  avatar: any;
  name: string;
  email?: string;
  phone?: string;
  extension?: string;
  laborRate?: number | null;
  selectCardClick: (e: any) => void;
}

const NonAppCrewCard = ({
  id,
  avatar,
  name,
  email,
  phone,
  extension,
  laborRate,
  selectCardClick,
}: Props) => (
  <div
    className={classes.container}
    id={id?.toString()}
    role="button"
    tabIndex={0}
    onKeyUp={selectCardClick}
    onClick={selectCardClick}
  >
    <div className={classes.header}>
      {avatar}
      <div className={classes.name}>{name}</div>
    </div>
    {(email || phone || laborRate != null) && (
      <div className={classes.body}>
        {email && (
          <div className={classes.email}>
            <EmailAnchor address={email}>{email}</EmailAnchor>
          </div>
        )}
        {phone && (
          <div className={classes.phone}>
            <PhoneAnchor phone={phone}>
              {phone} {extension?.length > 0 && <span>{`\u2022 Ext ${extension}`}</span>}
            </PhoneAnchor>
          </div>
        )}
        {laborRate != null && (
          <div className={classes.rate}>{formatCurrency(laborRate, 'USD')}/hr</div>
        )}
      </div>
    )}
  </div>
);

NonAppCrewCard.defaultProps = {
  email: undefined,
  phone: undefined,
  extension: undefined,
  laborRate: null,
};

const NonAppCrewCardMemo = memo(NonAppCrewCard, areEqual);

export { NonAppCrewCardMemo as NonAppCrewCard };
